// import { getEmployeeDetailsFromLdapRequestSchema } from "@pbz/schema/features";

import { keepPreviousData, useMutation, useQuery } from "@tanstack/react-query";

import type { GetAllActiveRolesResponseType } from "@pbz/schema/master";
import type { ListUsersRequestType } from "@pbz/schema/user";

import { QUERY_KEYS, USER_STATUS_IDS } from "@/utils/constants";
import { orpc } from "@/utils/orpc-client";

// Validation schema for matrix ID
// const matrixIdSchema = getEmployeeDetailsFromLdapRequestSchema.pick({
//   matrixId: true,
// });

export function useGetAllActiveRoles() {
  return useQuery<GetAllActiveRolesResponseType>(
    orpc.master.getAllActiveRoles.queryOptions({
      input: {},
      queryKey: [QUERY_KEYS.ROLES],
    }),
  );
}

export function useGetEmployeeDetailsFromLdap(
  //   {
  //   onSuccess,
  //   onError,
  // }: {
  //   onSuccess: (data: { message: string }) => void;
  //   onError: (error: Error) => void;
  // }
) {
  return useMutation(orpc.feature.getEmployeeDetailsFromLdap.mutationOptions());
}

export function getUsers({
  currentPage,
  usersPerPage,
  searchTerm,
  roleId,
  status,
}: {
  currentPage: number;
  usersPerPage: number;
  searchTerm: string;
  roleId?: number;
  status?: number;
}) {
  const reqBody: ListUsersRequestType = {
    offset: (currentPage - 1) * usersPerPage,
    limit: usersPerPage * currentPage,
    // search: searchTerm.trim(),
    roleId,
    status,
  };

  // Only add search if it's not empty
  if (searchTerm.trim()) {
    reqBody.search = searchTerm;
  }
  // TODO: validate the request body
  return useQuery(
    orpc.user.listUsers.queryOptions({
      input: { ...reqBody },
      context: { cache: true },
      queryKey: [
        "users",
        {
          page: currentPage,
          search: searchTerm.trim(),
          roleId,
          status,
        },
      ],
      placeholderData: keepPreviousData,
    }),
  );
}

export function useGetUsersForParentDropdown(
  roleId: number | null | undefined,
) {
  return useQuery({
    ...orpc.user.listUsers.queryOptions({
      input: {
        limit: 100, // Get more users for dropdown
        roleId: roleId || undefined,
        offset: 0,
        status: USER_STATUS_IDS.ACTIVE,
      },
      context: { cache: true },
      queryKey: ["users", "parent-dropdown", roleId],
    }),
  });
}

export function useCreateUser({
  onSuccess,
  onError,
}: {
  onSuccess: (data: { message: string }) => void;
  onError: (error: Error) => void;
}) {
  return useMutation(
    orpc.user.createUser.mutationOptions({
      onSuccess: (response) => onSuccess(response.data),
      onError,
    }),
  );
}

export function useUpdateUserPersonalDetails({
  onSuccess,
  onError,
}: {
  onSuccess: (data: { message: string }) => void;
  onError: (error: Error) => void;
}) {
  return useMutation(
    orpc.user.updateBasicInfo.mutationOptions({
      onSuccess: (response) => onSuccess(response.data),
      onError,
    }),
  );
}

export function useSendOtp({
  onSuccess,
  onError,
}: {
  onSuccess: (data: { message: string }) => void;
  onError: (error: Error) => void;
}) {
  return useMutation(
    orpc.feature.sendOtp.mutationOptions({
      onSuccess: (response) => onSuccess(response.data),
      onError,
    }),
  );
}

export function useVerifyMobileOtp({
  onSuccess,
  onError,
}: {
  onSuccess: (data: { message: string }) => void;
  onError: (error: Error) => void;
}) {
  return useMutation(
    orpc.feature.verifyOtp.mutationOptions({
      onSuccess: (response) => onSuccess(response.data),
      onError,
    }),
  );
}

export function useGetUserDetails(userId: string | null) {
  return useQuery({
    ...orpc.user.getUserDetails.queryOptions({
      input: { userId: userId || "" },
      queryKey: ["userDetails", userId],
    }),
    enabled: !!userId,
  });
}
